(function () {
    'use strict';

    function main() {
        var controller = {
            init: function () {
                controller.bind();
            },

            bind: function () {
                var widgets = wo$('[data-widget-type="mobile-phone-search-form"]');
                if (!widgets.length) return;

                var doSearch = function (url) {
                    var win = window.open(url, '_top');
                    win.focus();
                };

                var selectValuesFromQuery = function (widget) {
                    var query = decodeURIComponent(wo$(widget).find('[data-search-button]').data('query'));

                    var simOnly = WhistleOut.getQueryStringParameter('simonly', query);
                    if (simOnly) {
                        wo$(widget).find('select#phone-select option[value="-1"]').prop('selected', true);
                    }

                    var phone = WhistleOut.getQueryStringParameter('phone', query);
                    if (phone) {
                        wo$(widget)
                            .find('select#phone-select [data-shorturl="' + phone + '"]')
                            .prop('selected', true);
                    }

                    var data = WhistleOut.getQueryStringParameter('data', query);
                    if (data) {
                        wo$(widget)
                            .find('select#data-select option[value="' + data + '"]')
                            .prop('selected', true);
                    }
                };

                for (var index = 0; index < widgets.length; index++) {
                    selectValuesFromQuery(widgets[index]);
                }

                widgets.off('click');

                widgets.on('click', '[data-search-button]', function () {
                    wo$(this).find('.fa-spinner').show();

                    WhistleOut.trackEvent('MobilePhoneSearchForm', 'Search');

                    var widget = wo$(this).parents('[data-widget-type="mobile-phone-search-form"]');
                    var searchUrl = wo$(this).data('searchurl');
                    var detectLocation = wo$(this).data('detectlocation');
                    var initialQueryParams = wo$(this).data('query');

                    var phoneSelectElement = widget.find('#phone-select');
                    var selectedPhoneOption = phoneSelectElement.find('option:selected');
                    var selectedPhoneShortUrl = selectedPhoneOption.data('shorturl');

                    var data = widget.find('#data-select').val();

                    var queryString = '';

                    if (initialQueryParams) {
                        queryString = decodeURIComponent(initialQueryParams);
                        if (queryString.indexOf('?') === -1) queryString = '?' + queryString;
                    }

                    if (selectedPhoneShortUrl === '') {
                        queryString = WhistleOut.updateQueryStringParameter(queryString, 'phone', null);
                    } else if (selectedPhoneShortUrl) {
                        queryString = WhistleOut.updateQueryStringParameter(
                            queryString,
                            'phone',
                            selectedPhoneShortUrl
                        );
                        queryString = WhistleOut.updateQueryStringParameter(queryString, 'simonly', null);
                    }

                    if (selectedPhoneOption.val() === '-1') {
                        queryString = WhistleOut.updateQueryStringParameter(queryString, 'simonly', true);
                    }

                    if (data && data !== '0') {
                        queryString = WhistleOut.updateQueryStringParameter(queryString, 'data', data);
                    }

                    if (detectLocation === true || detectLocation === 'True') {
                        WhistleOut.getCurrentLocation(
                            function (e) {
                                var address = e.label;
                                if (address && address.length > 1) {
                                    queryString = WhistleOut.updateQueryStringParameter(
                                        queryString,
                                        'address',
                                        address.replace(/\s+/g, '+')
                                    );
                                }
                                doSearch(searchUrl + queryString);
                            },
                            function () {
                                doSearch(searchUrl + queryString);
                            }
                        );
                    } else {
                        doSearch(searchUrl + queryString);
                    }
                });
            }
        };

        WhistleOut.initWidget = controller.init;
        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
